import { render, staticRenderFns } from "./EmployeeTagNew.vue?vue&type=template&id=2c306d96&scoped=true"
import script from "./EmployeeTagNew.vue?vue&type=script&lang=ts"
export * from "./EmployeeTagNew.vue?vue&type=script&lang=ts"
import style0 from "./EmployeeTagNew.vue?vue&type=style&index=0&id=2c306d96&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c306d96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c306d96')) {
      api.createRecord('2c306d96', component.options)
    } else {
      api.reload('2c306d96', component.options)
    }
    module.hot.accept("./EmployeeTagNew.vue?vue&type=template&id=2c306d96&scoped=true", function () {
      api.rerender('2c306d96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/employee/EmployeeTagNew.vue"
export default component.exports